<template>
  <tr>
    <td>{{ mentor.alumno.nombre }} {{ mentor.alumno.apellido }}</td>
    <td>{{ fecha(mentor.fecha_inicio) }}</td>
    <td>{{ mentor.condicion.nombre }}</td>
    <td class="botones_mesa_examen">
      <button @click="mostrarModalFinalizarMentoria()"  class="boton_editar_socio boton_pagos_lista icon-pencil-square-o tabla-link"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarFinalizarMentoria"
      >
        <div class="contenedor-form-finalizar-mentoria">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <form
            action="#"
            @submit.prevent="finMentoriaAbierta(mentoria, mentor.mentoria_id)"
            class="form_editar_password"
            ref="modalRef1"
          >
            <div class="form_section_editar_password contenedor-ojo">
              <label for="fecha_finalizacion">Fecha de finalización</label>
              <input
                type="date"
                name="fecha_finalizacion"
                id="fecha_finalizacion"
                v-model="mentoria.fecha_finalizacion"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.fecha_finalizacion !== null"
              >
                {{ errores.fecha_finalizacion[0] }}
              </div>
            </div>
            <div class="form_section_editar_password contenedor-ojo">
              <label for="comentario_final_mentor">Observaciones</label>
              <textarea
                name="comentario_final_mentor"
                id="comentario_final_mentor"
                v-model="mentoria.comentario_final_mentor"
              ></textarea>
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.comentario_final_mentor !== null"
              >
                {{ errores.comentario_final_mentor[0] }}
              </div>
            </div>
            <button type="submit">Finalizar Mentoría</button>
          </form>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
// import examenService from '../services/examen'
// import BaseLoader4 from '../components/BaseLoader4.vue'
import mentorService from '../services/mentor'
export default {
  name: 'MentoriasAbiertasListaItem',
  components: {
    // BaseLoader4
  },
  props: ['mentor'],
  data: function () {
    return {
      mostrarFinalizarMentoria: false,
      mentoria: {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      },
      errores: {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      }
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    mostrarModalFinalizarMentoria () {
      this.mostrarFinalizarMentoria = true
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    closeModalOnClickOutside (event) {
      const modal = this.$refs.modalRef1
      console.log('aaaaaaa11111')
      console.log(modal)
      if (!modal.contains(event.target)) {
        console.log('wewewwewew')
        this.cerrarModalFinalizarMentoria()
      }
    },
    cerrarModalFinalizarMentoria () {
      console.log('222222')
      this.errores = {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      }
      document.removeEventListener('mouseup', this.closeModalOnClickOutside)
      this.mostrarFinalizarMentoria = false
      // this.errores2 = {
      //   password_nueva: null,
      //   password_nueva_confirmacion: null
      // }
      // this.mentoria = {
      //   fecha_finalizacion: null,
      //   comentario_final_mentor: null
      // }
      // saco el overflow del body
      const body = document.body
      body.style.overflow = 'auto'
    },
    finMentoriaAbierta (mentoria, id) {
      console.log(mentoria)
      console.log(id)
      mentorService
        .finMentoria(mentoria, id)
        .then(respuesta => {
          // this.cargando = false
          if (respuesta.success) {
            this.errores = {
              fecha_finalizacion: null,
              comentario_final_mentor: null
            }
            this.cerrarModalFinalizarMentoria()
            this.$emit('refrescar')
          } else {
            this.errores = {
              fecha_finalizacion: null,
              comentario_final_mentor: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.cerrarModalFinalizarMentoria()
      }
    })
  }
}
</script>

<style>

</style>
